import {CategoryTree} from '__generated__/__types__';
import Link from '@/_application/core/components/ui/link';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {Image} from '@/_application/core/components/ui/image';
import {getCategoryUrl} from '@/_application/modules/categories/models/url';
import {convertPathToImageUrl} from '@/_application/helpers/cdn-image';

const SubCategoryListMobile = ({categories}: {categories: CategoryTree[]}) => {
    if (!categories?.length) return <></>;
    return (
        <div className="mt-4 h-[150px]! bg-white pb-2">
            <p className="ml-4 pt-3 text-base font-bold text-primary">Danh mục</p>

            <Swiper slidesPerView={4} className="ml-4! mt-2">
                {categories.map(
                    category =>
                        category.featured_icon && (
                            <SwiperSlide key={category?.id}>
                                <Link href={getCategoryUrl(category)} className="h-full">
                                    <div className="flex h-full w-[70%] flex-col content-center items-center justify-center">
                                        <Image
                                            src={convertPathToImageUrl(category.featured_icon ?? '')}
                                            alt="category"
                                            width={57}
                                            height={57}
                                        />
                                        <p className="mt-2 line-clamp-2 text-center text-xs font-medium">
                                            {category.name}
                                        </p>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ),
                )}
            </Swiper>
        </div>
    );
};

export default SubCategoryListMobile;
